module.exports={
  "Play %s": "Spille %s",
  "Close": "Luk"
}
